var React = require('react');

function Fibo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Heavy Fighter"),React.createElement("g",{"id":"layer1","key":2},React.createElement("path",{"id":"path1404-0","className":"cls-1","d":"M94,69l10,10,10-10V49L104,39H24L14,49V69L24,79,34,69,54,89H74Z"}))]);
}

Fibo.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Fibo;

Fibo.default = Fibo;
